import {FC} from 'react'
import WaitingListGrid from './components/WaitingListGrid'

const WaitingListPage: FC = () => {
  return (
      <WaitingListGrid />
  )
}

export {WaitingListPage}
